import moment from 'moment';

function EventReservation( eventReservationId, description, endTime, eventTypeId, minNoOfAdultsPerBooking, minNoOfCadetsPerBooking, noOfCadetRacers, noOfRacers, noOfTotalRacers, notes, startTime, status, subject, externalSystemId, typeId, hidden ) {

  this.eventReservationId = eventReservationId;
  this.description = description;
  this.endTime = endTime;
  this.eventTypeId = eventTypeId;
  this.minNoOfAdultsPerBooking = minNoOfAdultsPerBooking;
  this.minNoOfCadetsPerBooking = minNoOfCadetsPerBooking;
  this.noOfCadetRacers = noOfCadetRacers; //Maximum number of cadet racers
  this.noOfRacers = noOfRacers; //Maximum no of adult racers on event
  this.noOfTotalRacers = noOfTotalRacers; //Maximum no of racers in total on event
  this.notes = notes;
  this.startTime = startTime;
  this.status = status; //1 - Unconfirmed, 2 - reserved, 3 - confirmed, 4 - canceled, 5 - closed
  this.subject = subject;
  this.typeId = typeId; //needed as dictates which track to show unde ron calendar
  this.hidden = hidden;

  this.event = {};
  this.checks = {};

  this.userId = 2; //web user

  this.externalSystemId = externalSystemId;

}

EventReservation.prototype.getCurrentParticipants = function ( product = null ) {
  let participants = 0;
  //check if reservation
  if (typeof(this.checks) !== 'undefined' ) {
    let checkKeys = Object.keys(this.checks);
    for (const checkId of checkKeys) {
      //check if chekc exists
      if(this.checks[checkId]){

        if(this.checks[checkId].checkDetails){
          //loop through checkdetails
          let checkDetailKeys = Object.keys(this.checks[checkId].checkDetails)
          for( const checkDetailId of checkDetailKeys){
            let checkDetail = this.checks[checkId].checkDetails[checkDetailId];
            if( checkDetail.status !== 2 ){
              let rPoints = checkDetail.r_Points;
              let qty = checkDetail.qty;
              let points = (rPoints) ? parseInt(rPoints, 10) * parseInt(qty, 10) : 0 ;
              participants += points;
              let cadetQty = parseInt(checkDetail.cadetQty, 10);
              participants += cadetQty;
            }
          }
        }

      }
    }
  }
  this.participants = participants;
  return this.participants;
}

EventReservation.prototype.createEventReservationOnApi = function( api ){
  return new Promise( function(resolve, reject) {

    let start = moment(this.eventScheduledTime);
    let end = moment(this.eventScheduledTime).add(parseInt(this.eventDuration, 10), 'm');

    let createEventReservationString = api.base_url + 'eventreservations?key=' + api.api +
      '&allowOnlineReservation=true' +
      '&description=' + this.description +
      '&endTime=' + this.endTime +
      '&eventTypeId=' + this.eventTypeId +
      '&isEventClosure=false' +
      '&minNoOfAdultsPerBooking=0' +
      '&minNoOfCadetsPerBooking=0' +
      '&noOfRacers=' + this.noOfRacers +
      '&noOfCadetRacers=' +  this.noOfCadetRacers + //can use participants in event to set this
      '&noOfTotalRacers=' + this.noOfTotalRacers + //remember this is maximum number
      '&notes=Online booking' + this.subject +
      '&ptsPerReservation=1' +
      '&repId=3' + //House
      '&startTime=' + this.startTime +
      '&status=2' + //2 - reserved
      '&subject=' + this.subject +
      '&typeId=' + this.typeId + //this is eventReservationType - this dictates track in calendar on clubspeed!
      '&userId=' + this.userId + //2 - web user
      '&externalSystemId=KNE Website online booking system';

    fetch( createEventReservationString, {method: 'POST'} )
      .then( response => {
        if( !response.ok ){
          throw Error(response.statusText);
        }
        return response;
      })
      .then( response =>
        response.json()
      )
      .then( newEventReservationId => {
        resolve(newEventReservationId);
      })
      .catch( err => {
        reject(err);
      })

  }.bind(this))
}

//make reservation promise chain
EventReservation.prototype.setId = function (eventReservationId, api){
  return new Promise( function( resolve, reject){
    if(!eventReservationId){
      this.createEventReservationOnApi( api )
        .then( newEventReservationId => {
          this.eventReservationId = newEventReservationId;
          resolve( newEventReservationId );
        })
    } else {
      this.eventReservationId = eventReservationId;
      resolve( eventReservationId);
    }
  }.bind(this))
}

EventReservation.prototype.getChecks = function( api ){
  return new Promise( function( resolve, reject ){

    this.getEventReservationLinks( api )
      .then( eventReservationLinks => {
        let checkIds = [];
        eventReservationLinks.forEach( function( eventResLink ){
          checkIds.push( eventResLink.checkId )
        })
        //fetch checks
        let checksQueryString = api.base_url + 'checks?key=' + api.api + '&where={"checkId":{"in":[' + checkIds + ']}}';
        return fetch( checksQueryString)
      })
      .then( response => api.checkResponse(response) )
      .then( response => api.returnJson(response) )
      .then( checks => {
        resolve(checks)
      })
      .catch( err => {
        reject(err)
      })

  }.bind(this))
}

EventReservation.prototype.getEventReservationLinks = function( api ){
  return new Promise( function( resolve, reject ){

    let eventReservationLinkString = api.base_url + 'eventReservationLinks?key=' + api.api + '&where={"reservationId":' + this.eventReservationId + '}';
    fetch( eventReservationLinkString)
      .then( response => api.checkResponse(response) )
      .then( response => api.returnJson(response) )
      .then( eventReservationLinks => {
        resolve(eventReservationLinks)
      })
      .catch( err => {
        reject(err)
      })
  }.bind(this))
}

EventReservation.prototype.setStatus = function( status, api ){
  return new Promise( function( resolve, reject ) {
    console.info('setting event status to ' + status);
    this.status = status;
    let putEventResStatusString =  api.base_url + 'eventreservations/' + this.eventReservationId + '?key=' + api.api + '&status=' + status;

    fetch(putEventResStatusString, {
      method: 'PUT',
      cors: 'cors'
    })
      .then( response => {
        console.log(response)
        resolve(response)
      })
  }.bind(this))
}

EventReservation.prototype.removeCheck = function( checkId, api ){
  console.info('Removing check ' + checkId + '...');
  return new Promise( function( resolve, reject ){
    //remove from object if exists
    if( this.checks[checkId] ){
      delete this.checks[checkId];
    }
    //if last check set event delete to true
    this.getChecks( api )
      .then( checks => {
        let checkCnt = 0;
        checks.checks.forEach( function(check){
          if( check.status==0 ){
            checkCnt++;
          }
        })
        resolve( checkCnt );
      })
      .catch( err => {
        reject(err)
      })

  }.bind(this))
}


export default EventReservation;
